import { render, staticRenderFns } from "./ObligorDataList.vue?vue&type=template&id=86a5f972"
import script from "./ObligorDataList.vue?vue&type=script&lang=js"
export * from "./ObligorDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports